import type { Pageable, Sortable } from '@empathyco/playboard-core-domain'
import type { DeepPartial } from '@empathyco/x-utils'
import type { FeatureIdEnum } from '../../enums'

export enum PlatformToolReportToolEnum {
  'PROMOTIONS' = 'promotions',
}

export interface PlatformToolReportingListParams {
  start_date: string
  end_date: string
  tool: PlatformToolReportToolEnum
  offset?: number
  rows?: number
  sort_field?: string
  sort_order?: string
}
export interface ToolReportingListParams extends DeepPartial<Pageable>, Partial<Sortable> {
  startDate: string
  endDate: string
  tool: FeatureIdEnum
  toolId?: string
}

export interface ToolReportingDailyParams extends ToolReportingListParams {
  toolId: string
}
